module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gc-Ha-Ib-Ja.42149f44.png";